module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"badge":"AI size recommendation"}}')
  delete Component.options._Ctor
}
